let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("v473E")).then(() => parcelRequire('aFqMa'));